module.exports = __webpack_public_path__ + "img/bg_avatar_male_23.1783bfde.png";